import {
  Activity,
  Archive,
  AlertTriangle,
  ArrowUpRight,
  BadgeCheck,
  BellRing,
  Book,
  BookOpen,
  Building2,
  CalendarClock,
  Calendar,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  ChevronsUpDown,
  Circle,
  CirclePlay,
  ClipboardList,
  Clock,
  Database,
  ExternalLink,
  FileSignature,
  FileText,
  Fingerprint,
  FolderKanban,
  Gauge,
  GitBranch,
  GitMerge,
  Home,
  KeyRound,
  LayoutTemplate,
  Lock,
  LogOut,
  MonitorSmartphone,
  Percent,
  PencilRuler,
  Plug,
  Rocket,
  Share2,
  SquareCheckBig,
  UsersRound,
  Inbox,
  Kanban,
  Languages,
  LayoutDashboard,
  Lightbulb,
  LifeBuoy,
  ListPlus,
  Mail,
  Map,
  Megaphone,
  Menu,
  Mic,
  MicOff,
  MessageSquare,
  MessagesSquare,
  Milestone,
  PanelLeftClose,
  Paperclip,
  Phone,
  PhoneOff,
  PhoneOutgoing,
  Play,
  Plus,
  Radio,
  Receipt,
  RefreshCw,
  ReceiptText,
  ScrollText,
  Search,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Siren,
  Sliders,
  Sparkles,
  Ticket,
  Timer,
  UserPlus,
  UserRound,
  Users,
  BarChart3,
  Eye,
  MessageSquareText,
  Smartphone,
  Table,
  X,
  type LucideIcon,
} from "lucide-react";

// kebab-case (from the design/data) → lucide component. Unknown names fall back
// to a neutral circle so a missing icon never breaks a screen.
const MAP: Record<string, LucideIcon> = {
  activity: Activity,
  archive: Archive,
  "alert-triangle": AlertTriangle,
  "arrow-up-right": ArrowUpRight,
  "badge-check": BadgeCheck,
  "bell-ring": BellRing,
  book: Book,
  "book-open": BookOpen,
  "building-2": Building2,
  "calendar-clock": CalendarClock,
  calendar: Calendar,
  "check-circle": CheckCircle,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "chevrons-up-down": ChevronsUpDown,
  circle: Circle,
  "circle-play": CirclePlay,
  "clipboard-list": ClipboardList,
  clock: Clock,
  database: Database,
  "external-link": ExternalLink,
  "file-signature": FileSignature,
  "file-text": FileText,
  fingerprint: Fingerprint,
  "folder-kanban": FolderKanban,
  gauge: Gauge,
  "git-branch": GitBranch,
  "git-merge": GitMerge,
  home: Home,
  "key-round": KeyRound,
  "layout-template": LayoutTemplate,
  lock: Lock,
  "log-out": LogOut,
  "monitor-smartphone": MonitorSmartphone,
  percent: Percent,
  "pencil-ruler": PencilRuler,
  plug: Plug,
  rocket: Rocket,
  "share-2": Share2,
  "square-check-big": SquareCheckBig,
  "users-round": UsersRound,
  inbox: Inbox,
  kanban: Kanban,
  languages: Languages,
  "layout-dashboard": LayoutDashboard,
  lightbulb: Lightbulb,
  "life-buoy": LifeBuoy,
  "list-plus": ListPlus,
  mail: Mail,
  map: Map,
  megaphone: Megaphone,
  menu: Menu,
  mic: Mic,
  "mic-off": MicOff,
  "phone-off": PhoneOff,
  "message-square": MessageSquare,
  "messages-square": MessagesSquare,
  milestone: Milestone,
  "panel-left-close": PanelLeftClose,
  paperclip: Paperclip,
  phone: Phone,
  "phone-outgoing": PhoneOutgoing,
  play: Play,
  plus: Plus,
  radio: Radio,
  receipt: Receipt,
  "refresh-cw": RefreshCw,
  "receipt-text": ReceiptText,
  "scroll-text": ScrollText,
  search: Search,
  settings: Settings,
  shield: Shield,
  "shield-alert": ShieldAlert,
  "shield-check": ShieldCheck,
  siren: Siren,
  sliders: Sliders,
  sparkles: Sparkles,
  ticket: Ticket,
  timer: Timer,
  "user-plus": UserPlus,
  "user-round": UserRound,
  users: Users,
  "bar-chart-3": BarChart3,
  eye: Eye,
  "message-square-text": MessageSquareText,
  smartphone: Smartphone,
  table: Table,
  x: X,
};

export function Icon({
  name,
  size = 18,
  color = "currentColor",
  strokeWidth = 2,
  style,
}: {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}) {
  const Cmp = MAP[name] ?? Circle;
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} style={{ flex: "none", ...style }} />;
}
